// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultColorTheme.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Default Color Theme Component
 */
import React, { Component } from 'react';
import { observe } from 'mobx';
import { isUndefined } from 'lodash/fp';
import UiState from 'logic/Izenda.UiState';
import Panel from 'share/components/controls/Izenda.Panel';
import connect from 'share/enhancers/Izenda.Connect';
import ColorPaletteSetting from 'share/components/controls/ColorPalette/Izenda.ColorPaletteSetting';

@connect()
export default class DefaultColorTheme extends Component {
  componentDidMount() {
    const { store } = this.props;
    this.disposeTenantObservation = observe(UiState, 'tenantId', () => {
      if (UiState.silentUpdate) return;
      store.reportConfiguration.resetData();
      store.loadDefaultTheme();
    });
  }

  componentWillUnmount() {
    this.disposeTenantObservation();
  }

  render() {
    const {
      localization,
      store: {
        reportConfiguration,
        reportConfiguration: { defaultColorTheme }
      }
    } = this.props;

    const DefaultColorThemeHeaderPanel = connect()(props => (
      <div onClick={props.collapseToggle}>
        <i className="icon-toggle-triangle" />
        <strong>{localization.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_COLOR_THEME_HEADER')}</strong>
      </div>
    ));

    const header = {
      className: 'u-bgGray',
      component: DefaultColorThemeHeaderPanel
    };

    return (
      <Panel
        header={header}
        collapsible
        expanedOption
        panelBodyClassName="izenda-ReportConfiguration-DefaultColorTheme_Body"
      >
        <div className="izenda-ReportConfiguration-DefaultColorTheme_Info">
          {localization.getText('SYSTEM_CONFIGURATION_REPORT_DEFAULT_COLOR_THEME_INFO')}
        </div>
        {!isUndefined(defaultColorTheme.value) && (
          <ColorPaletteSetting
            selectedPaletteName={defaultColorTheme.value}
            selectionPopupTitle={localization.getText('COLORTHEME_POPUP_HEADER_DEFAULT')}
            defaultColorThemeLabel={localization.getText('COLORPALETTE_NODEFAULT')}
            displaySettingStatus={false}
            updateSelectedPalette={reportConfiguration.setValueByKey.bind(reportConfiguration, 'defaultColorTheme')}
            needMaskDefault={false}
          />
        )}
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Report/Izenda.DefaultColorTheme.js